import styled from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

export const StyledFilterCardsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    align-items: start;
`;

export const StyledFilterCardsColumn = styled(Stack)`
    gap: 8px;
    min-width: 0;
`;
